import { PermissionMapping } from '@@/lib/permissions';

export type DfcPermission = 'writer' | 'reader';

const dfcPermissionMapping: PermissionMapping<DfcPermission>[] = [
  {
    permissionSetMapping: {
      writer: ['dfc-admin'],
      reader: ['dfc-admin']
    },
    urlSignature: '/browser',
    showInNavbar: true,
    label: 'Browser'
  }
];

export default dfcPermissionMapping;
